import { JoinColumn, ManyToOne } from "typeorm";
import { User } from "./reg_users.entity";

export abstract class AuditableEntity {

  @ManyToOne(() => User)
  @JoinColumn({ name: "created_by_id_user_fk" })
    userCreatedBy?: User;

  @ManyToOne(() => User)
  @JoinColumn({ name: "last_modified_by_id_user_fk" })
    userLastModifiedBy?: User;

}
